// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__SrEkw","title":"Sidebar_title__EoL4N","list":"Sidebar_list__CpX1S","list_item":"Sidebar_list_item__ASukF"};